<div class="w-full bg-gray-lighter shadow-md rounded-lg sahdow-lg overflow-hidden flex flex-col justify-center items-center">
    <div>
        <img class="object-center object-cover h-auto w-full" [src]="player.ImageUrl" alt="photo">
    </div>
    <div class="text-center py-8 sm:py-6">
        <p class="text-xl text-gray-700 font-bold mb-2">{{player.FirstName}} {{player.LastName}}</p>
        <p class="text-base text-gray-400 font-normal">{{player.Number}}</p>
    </div>
</div>